exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.single-customer[data-v-754d00d0]{width:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}div.single-customer section[data-v-754d00d0]{width:33.3333%;height:auto}div.single-customer section label[data-v-754d00d0]{display:block;width:100%}div.single-customer section.credentials[data-v-754d00d0]{text-align:right}", ""]);

// exports
